import firebase from 'firebase';
import 'firebase/storage';

export const app = firebase.initializeApp({
  projectId: 'res-dwn',
  appId: '1:271946943533:web:dce9606391263cc2e0fca4',
  databaseURL: 'https://res-dwn.firebaseio.com',
  storageBucket: 'res-dwn.appspot.com',
  locationId: 'europe-west',
  apiKey: 'AIzaSyCdaqryxf4fj3-kIYohukwBjIcH4ROaP34',
  authDomain: 'res-dwn.firebaseapp.com',
  messagingSenderId: '271946943533',
});
